import React from "react";
import { DollarSign, AlertTriangle } from "lucide-react";
import { Modal } from "./Modal";

/* Confirmación explícita antes de cambiar la vista a dólares.
 * La moneda predeterminada es Bs; pagar en $ exige un comprobante de Zinli o
 * Binance Pay, así que el cambio nunca debe ocurrir por un toque accidental. */
export function CurrencyUsdConfirmDialog({ open, onCancel, onConfirm }) {
  if (!open) return null;
  return (
    <Modal onClose={onCancel} size="sm" testId="currency-usd-confirm-modal">
      <div className="flex items-center gap-3">
        <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-green-500/20 border border-green-400/40">
          <DollarSign className="w-5 h-5 text-green-300" />
        </span>
        <h3 className="text-lg font-extrabold text-white">¿Cambiar a dólares?</h3>
      </div>

      <div className="flex gap-3 p-3 rounded-xl bg-amber-950/30 border border-amber-500/40">
        <AlertTriangle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
        <p className="text-xs text-amber-200 leading-relaxed">
          Vas a ver los precios en <strong>dólares</strong>. Si pagas en esta moneda,
          tu comprobante debe ser de <strong>Zinli o Binance Pay</strong> y el monto se
          escribe en <strong>$</strong>.
        </p>
      </div>

      <p className="text-xs text-zinc-400 leading-relaxed">
        Si vas a pagar por <strong className="text-cyan-300">Pago Móvil o
        Transferencia</strong> (bolívares), quédate en <strong>Bs</strong>.
      </p>

      <div className="flex gap-2 pt-1">
        <button
          type="button"
          onClick={onCancel}
          data-testid="currency-usd-cancel-btn"
          className="flex-1 px-4 py-2.5 rounded-xl border border-zinc-700 text-zinc-300 text-xs font-bold uppercase tracking-widest hover:bg-zinc-800 transition-colors"
        >
          Seguir en Bs
        </button>
        <button
          type="button"
          onClick={onConfirm}
          data-testid="currency-usd-confirm-btn"
          className="flex-1 px-4 py-2.5 rounded-xl bg-green-500/25 border border-green-400/60 text-green-100 text-xs font-bold uppercase tracking-widest hover:bg-green-500/35 transition-colors"
        >
          Sí, cambiar a $
        </button>
      </div>
    </Modal>
  );
}
